import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { setOpenLoginModal } from '../../../../store/actions';

const LikeProductHeartWrapper = styled.svg`
  display: block;
  margin-left: auto;

  cursor: pointer;
  fill: ${props => (props.favorite ? '#a83569' : '#D3D3D3')};
  path {
    stroke: ${props => (props.favorite ? '#a83569' : '#D3D3D3')};
  }

  @media (max-width: 992px) {
    width: 23px;
    height: auto;
  }
`;

const HeartWrapper = styled.div``;

function LikeProductHeart(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      if (location.pathname.endsWith('/review') && !props.isAuthenticated) {
        dispatch(setOpenLoginModal(true));
      }
    }

    return () => {
      unmounted = true;
    };
  }, []);

  return (
    <HeartWrapper>
      <LikeProductHeartWrapper
        favorite={props.favorite}
        onClick={() => {
          if (props.isAuthenticated) {
            props.mutation();
            props.setFavorite(!props.favorite);
          } else {
            dispatch(setOpenLoginModal(true));
          }
        }}
        width="27"
        height="24"
        viewBox="0 0 27 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0292 4.69268L13.0293 4.69294L13.0295 4.6932L13.0296 4.69343L13.4729 5.7371L13.9439 4.7055L13.944 4.70533L13.9441 4.70509L13.9442 4.70475L13.9443 4.70465L13.9473 4.69824C13.9503 4.6919 13.9553 4.6815 13.9623 4.6673C13.9762 4.6389 13.9982 4.59536 14.0283 4.53884C14.0885 4.42572 14.1811 4.26105 14.3072 4.06202C14.5599 3.66312 14.9443 3.13094 15.4688 2.59988C16.5167 1.53881 18.1034 0.5 20.3188 0.5C22.1305 0.5 24.3114 1.54427 25.5219 3.34716C26.7007 5.10268 27.0017 7.64739 24.9412 10.7816C22.6576 14.255 19.7183 17.4397 17.3413 19.7617C16.1544 20.9212 15.1111 21.8622 14.3653 22.5128C14.0144 22.8189 13.7295 23.0606 13.5266 23.2303C13.5255 23.2292 13.5244 23.2281 13.5233 23.227C13.3139 23.0112 13.0095 22.6969 12.6303 22.303C11.8717 21.5151 10.8137 20.4092 9.61602 19.1371C7.21897 16.5911 4.26902 13.3862 2.04065 10.7346C0.232371 8.58281 0.230645 6.03884 1.26407 4.01261C2.3065 1.96873 4.37665 0.500002 6.66026 0.500004C8.94991 0.500005 10.5353 1.54154 11.5608 2.59698C12.0751 3.12627 12.4454 3.65658 12.6866 4.05389C12.807 4.25213 12.8945 4.41605 12.951 4.5285C12.9793 4.58469 12.9997 4.62791 13.0127 4.656C13.0192 4.67004 13.0238 4.68029 13.0265 4.68648L13.0292 4.69257L13.0292 4.69268Z"
          stroke="black"
          strokeOpacity="0.3"
        />
      </LikeProductHeartWrapper>
    </HeartWrapper>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(LikeProductHeart);
